import React from 'react';

import CheckCircle from '@ast/magma/components/icon/icons/CheckCircle';

import { Button } from '@ast/magma/components/button';
import { Dialog } from '@ast/magma/components/dialog';

import { useIsMobile } from '@app/common/utils/hooks/useIsMobile';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import styles from './Dialog.pcss';
import { useEscapeCloseHandler } from './useEscapeCloseHandler';

interface SuccessDialogProps {
  readonly onClose: () => void
}
export const SuccessDialog = ({ onClose }: SuccessDialogProps) => {
  const { t } = useUserSettingsTranslation();

  const isMobile = useIsMobile();

  useEscapeCloseHandler(onClose);

  return (
    <Dialog
      align={isMobile ? 'bottom' : 'center'}
      predefinedWidth="sm"
      data-stable-name="RegisteredPasskeySuccessDialog"
      status={{
        icon: <CheckCircle />,
        level: 'success',
      }}
    >
      <div className={styles.dialog}>
        <div
          className={styles.dialogTitle}
          data-stable-name="RegisteredPasskeySuccessTitle"
        >
          {t(
            'profile-and-security.register-passkey-success.dialog.content.title|Title of content in dialog',
            'Passkey was successfully added',
          )}
        </div>
        <div className={styles.dialogContent}>
          <div
            className={styles.text}
            data-stable-name="RegisteredPasskeySuccessContent"
          >
            {t(
              'profile-and-security.register-passkey-success.dialog.content.success-message|Success message',
              'Your new passkey is ready to use',
            )}
          </div>

          <Button
            data-stable-name="CloseButton"
            look="outlined"
            onClick={onClose}
          >
            {t(
              'profile-and-security.register-passkey-success.success-dialog.close-button|Close button label',
              'Close',
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
